import React from 'react';

export const Products = ({ data }) => {
  if (!data) return null;

  return (
    <section id="products">
      <div className="container">
        <div className="section-title">
          <span className="section-label">Our Work</span>
          <h2>Products We&apos;ve Built</h2>
          <p>
            From workforce management to family memories — we ship digital
            products that solve real problems.
          </p>
        </div>

        <div className="row">
          {data.map((product, index) => (
            <div key={index} className="col-md-4 col-sm-6">
              <div className={`product-card ${product.color}`}>
                <div className={`product-icon ${product.color}`}>
                  {product.logo
                    ? <img src={product.logo} alt={product.name} className="product-logo-img" />
                    : <i className={product.icon} aria-hidden="true"></i>
                  }
                </div>

                <div className="product-name">{product.name}</div>
                <p className="product-desc">{product.description}</p>

                <div className="product-footer">
                  <span className={`product-badge ${product.status}`}>
                    {product.status === 'live' ? '● Live' : '○ Coming Soon'}
                  </span>
                  {product.link && (
                    <a
                      href={product.link}
                      className="product-link"
                      {...(product.link.startsWith('http') ? { target: '_blank', rel: 'noreferrer' } : {})}
                    >
                      Learn more <i className="fa fa-arrow-right"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
